import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for `/libraries/material-catalog/*`.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const materialsCatalogRoute = defineRoute("/libraries/material-catalog");
export const materialCreateRoute = defineRoute("/libraries/material-catalog/add");
export const materialMergeRoute = defineRoute("/libraries/material-catalog/merge");
export const installTasksRoute = defineRoute("/libraries/material-catalog/install-tasks");
/** AI import wizard: `/libraries/material-catalog/import`, carrying `?proposal=ap:1` once the agent is running. */
export const materialImportRoute = defineRoute("/libraries/material-catalog/import");
/** Listing detail: `/libraries/material-catalog/ml:2?mv=mv:49` (or `?createNew=1`). Old `mv:` path params redirect. */
export const materialDetailsRoute = defineRoute("/libraries/material-catalog/:listingId");
export const materialCostRoute = defineRoute("/libraries/material-catalog/:variantId/cost");
